import { DomainCommonName } from '@foxtail-dev/datacontracts'
import { ListingDetailsDraft } from '@foxtail-dev/datacontracts/dist/lib/schemas/listings/ListingDetails'

// Replace with user-clients version
export const getAllMarkets = (listingDetails: ListingDetailsDraft): DomainCommonName[] => {
    return DomainCommonName.array().parse(Object.keys(listingDetails.domainSpecificDetails || {}))
}
